var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinanceLogoFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 21,
    viewBox: "0 0 100 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "binance 2",
    clipPath: "url(#clip0_29_6677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_i_29_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11599 8.82395L10.0004 4.74702L13.8864 8.82726L16.1454 6.45376L10.0004 0L3.85547 6.4521L6.11599 8.82395Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_i_29_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.000976562 10.5L2.25872 8.12736L4.51841 10.5L2.25872 12.8726L-0.000976562 10.5Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter2_i_29_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11622 12.1755L10.0007 16.2541L13.8867 12.1738L16.1472 14.544L16.1456 14.5457L10.0007 20.9994L3.8557 14.549L3.85254 14.5457L6.11622 12.1755Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter3_i_29_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4795 10.5L17.7392 8.12736L19.9989 10.5L17.7392 12.8726L15.4795 10.5Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    filter: "url(#filter4_i_29_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2925 10.5001L10.0004 8.0918L8.30536 9.87151L8.10948 10.0755L7.70824 10.4968L7.70508 10.5001L7.70824 10.5051L10.0004 12.9101L12.2925 10.5018L12.294 10.5001H12.2925Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    filter: "url(#filter5_i_29_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5244 5.08789H28.4404C29.6599 5.08789 30.5824 5.41962 31.208 6.08307C31.4437 6.32815 31.6294 6.62095 31.7541 6.9437C31.8787 7.26646 31.9396 7.61244 31.933 7.96065V7.99216C31.9373 8.27742 31.8995 8.56165 31.8209 8.83475C31.7509 9.06985 31.6493 9.29326 31.5192 9.49821C31.3979 9.69146 31.2511 9.86569 31.0832 10.0157C30.9192 10.1639 30.7395 10.2919 30.5477 10.3972C31.1008 10.5995 31.5982 10.9412 31.9962 11.3924C32.348 11.8126 32.5238 12.3931 32.5238 13.1339V13.1655C32.5338 13.6281 32.438 14.0866 32.2442 14.5023C32.0565 14.8853 31.7814 15.2136 31.4433 15.4577C31.0612 15.7267 30.6357 15.9206 30.1875 16.0299C29.655 16.1625 29.1092 16.2265 28.562 16.2207H23.5244V5.08789ZM27.9475 9.58943C28.3728 9.61101 28.7961 9.51492 29.1749 9.31078C29.3227 9.22017 29.4433 9.08794 29.5231 8.92906C29.603 8.77017 29.6389 8.59099 29.6267 8.4118V8.38028C29.6345 8.21518 29.6026 8.05066 29.5338 7.90194C29.4651 7.75322 29.3618 7.6251 29.2334 7.5294C28.9711 7.33368 28.5926 7.23583 28.0976 7.23583H25.7976V9.58943H27.9475ZM28.5683 14.076C28.9921 14.101 29.4138 13.9992 29.7847 13.7825C29.9291 13.685 30.0461 13.5487 30.1233 13.3876C30.2006 13.2266 30.2353 13.0468 30.2238 12.8669V12.8354C30.2295 12.6644 30.1952 12.4945 30.1239 12.3407C30.0525 12.1869 29.9464 12.0538 29.8147 11.953C29.543 11.7318 29.1038 11.6213 28.4972 11.6213H25.7976V14.076H28.5683Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    filter: "url(#filter6_i_29_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4521 5.08789H37.7853V16.224H35.4521V5.08789Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8",
    filter: "url(#filter7_i_29_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3164 5.08789H43.4679L48.4408 11.9414V5.08789H50.7439V16.224H48.7583L43.6227 9.14492V16.224H41.3164V5.08789Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9",
    filter: "url(#filter8_i_29_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.808 5.00977H59.9564L64.5011 16.2255H62.0653L61.0953 13.7276H56.6106L55.6407 16.2255H53.2617L57.808 5.00977ZM60.2629 11.5647L58.8506 7.95219L57.4447 11.5647H60.2629Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10",
    filter: "url(#filter9_i_29_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0244 5.08789H69.1759L74.1456 11.9414V5.08789H76.4488V16.224H74.4631L69.3276 9.14492V16.224H67.0244V5.08789Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_11",
    filter: "url(#filter10_i_29_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8459 16.4204C84.1023 16.4271 83.3651 16.2759 82.6786 15.9759C82.0322 15.6957 81.4459 15.2824 80.954 14.7606C80.4621 14.2387 80.0747 13.6188 79.8146 12.9373C79.5401 12.2244 79.4011 11.462 79.4055 10.6931V10.6616C79.3933 9.14598 79.9487 7.686 80.952 6.59628C81.4456 6.06398 82.0367 5.64198 82.6896 5.35562C83.3999 5.04672 84.1625 4.89267 84.9312 4.90281C85.3858 4.89925 85.8398 4.94202 86.2866 5.03053C86.6688 5.10644 87.0426 5.22372 87.4018 5.3805C87.7278 5.52458 88.0377 5.70591 88.3259 5.92122C88.6072 6.13121 88.8714 6.36533 89.1158 6.62116L87.6324 8.41912C87.2534 8.05196 86.8282 7.74112 86.3687 7.49526C85.9173 7.26863 85.422 7.15508 84.9217 7.16354C84.5054 7.15887 84.0929 7.24727 83.7116 7.42285C83.3303 7.59844 82.9889 7.8572 82.7102 8.18194C82.4338 8.50585 82.2174 8.88103 82.072 9.28825C81.9198 9.71859 81.8432 10.1744 81.8461 10.6334V10.6649C81.8446 11.1233 81.9211 11.5783 82.072 12.0084C82.2155 12.4171 82.4297 12.7944 82.7038 13.1214C82.9804 13.4501 83.3209 13.7127 83.7025 13.8913C84.084 14.0698 84.4977 14.1602 84.9154 14.1563C85.4473 14.1739 85.9752 14.0537 86.4524 13.8064C86.9068 13.5464 87.3268 13.2252 87.7019 12.851L89.1868 14.4267C88.9247 14.7255 88.6411 15.0028 88.3386 15.256C88.0413 15.5028 87.7186 15.7136 87.3765 15.8846C87.012 16.0648 86.6279 16.1979 86.2328 16.2811C85.7763 16.3772 85.3115 16.4239 84.8459 16.4204Z",
    fill: "#FEEB61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_12",
    filter: "url(#filter11_i_29_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9404 5.08789H99.9226V7.26734H94.2357V9.5264H99.2433V11.7059H94.2436V14.0445H100.002V16.224H91.9452L91.9404 5.08789Z",
    fill: "#FEEB61"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_29_6677",
    x: 3.85547,
    y: 0,
    width: 13.29,
    height: 9.82812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29_6677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_29_6677",
    x: -0.000976562,
    y: 8.12695,
    width: 5.51953,
    height: 5.74609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29_6677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_29_6677",
    x: 3.85254,
    y: 12.1738,
    width: 13.2949,
    height: 9.82617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29_6677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_29_6677",
    x: 15.4795,
    y: 8.12695,
    width: 5.51953,
    height: 5.74609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29_6677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_29_6677",
    x: 7.70508,
    y: 8.0918,
    width: 5.58887,
    height: 5.81836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29_6677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_29_6677",
    x: 23.5244,
    y: 5.08789,
    width: 10,
    height: 12.1328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29_6677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_29_6677",
    x: 35.4521,
    y: 5.08789,
    width: 3.33301,
    height: 12.1367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29_6677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_29_6677",
    x: 41.3164,
    y: 5.08789,
    width: 10.4277,
    height: 12.1367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29_6677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_29_6677",
    x: 53.2617,
    y: 5.00977,
    width: 12.2393,
    height: 12.2148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29_6677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_29_6677",
    x: 67.0244,
    y: 5.08789,
    width: 10.4248,
    height: 12.1367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29_6677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_29_6677",
    x: 79.4053,
    y: 4.90234,
    width: 10.7812,
    height: 12.5176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29_6677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_29_6677",
    x: 91.9404,
    y: 5.08789,
    width: 9.06152,
    height: 12.1367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29_6677"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_6677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 21,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceLogoFooter);
export default __webpack_public_path__ + "static/media/binance-logo-footer.4a45d1f8e76a248732aa23addbf5d72c.svg";
export { ForwardRef as ReactComponent };